/**
 * Embedded SDK Content Module
 *
 * This module provides the embedded SDK content for npm package users.
 * The actual content is generated at build time by scripts/build-embedded-sdk.js
 *
 * For development, this file exports placeholders.
 * After build, the dist/module/embeddedSDK.js will contain the actual SDK content.
 *
 * Usage in HTMLComponentLoader:
 * - If HAS_EMBEDDED_SDK is true, inject SDK inline: <script>${EMBEDDED_SDK_CONTENT}</script>
 * - If HAS_EMBEDDED_SDK is false, fall back to CDN: <script src="${url}"></script>
 */

/**
 * The embedded SDK content as a minified JavaScript string.
 * This placeholder will be replaced with actual content in the build output.
 */
export const EMBEDDED_SDK_CONTENT: string = '';

/**
 * Flag indicating whether embedded SDK content is available.
 * This is false in development, true in the built module.
 */
export const HAS_EMBEDDED_SDK: boolean = false;
